<div *ngIf="(stage?.contracts?.length??0)>0">
  <h4>{{stage.stage}}</h4>

<mat-button-toggle-group appearance="standard" (change)="onToggleChange($event)" value="close">
  <mat-button-toggle value="open" class="open-close-toggle">
    Open All
  </mat-button-toggle>
  <mat-button-toggle value="close" class="open-close-toggle">
    Close All
  </mat-button-toggle>
</mat-button-toggle-group>

  <div class="contract-stage-container">
    <div *ngFor="let contract of stage.contracts" class="contractContainer">
      <eic-contract [contract]="contract"
                    [stage]="stage.stage"
                    (contract_selected)="contractSelected($event)" 
                    (project_selected)="projectSelected($event)"   
                    [currentProject]="currentProject">
      </eic-contract>
    </div>
  </div>
</div>

